// for (let index = 0; index < document.querySelectorAll(".footer-section").length; index++) {
//     const element = document.querySelectorAll(".footer__title-row")[index]
//     const list = document.querySelectorAll(".footer__list")[index]
//     const icon = document.querySelectorAll(".footer__title-icon")[index]
//     element.onclick = function () {
//         list.classList.toggle('active')
//         icon.classList.toggle('active')
//     }
// }

$('.footer__title-row').click(function(){
    $(this).parent().toggleClass('open')
});